import React from 'react';
import './preloader.css';

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="loader"></div>
    </div>
  );
};

export default Preloader;